import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DATE_FORMAT, LOCALIZATION_LOCALE } from '../models/enums';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'dateFormatter',
  pure: false,
})
export class DateFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: Date, withoutYear?: boolean): string {
    if (!value) {
      return '';
    }

    let resultDate = this.getResult(
      value,
      this.translateService.currentLang as LOCALIZATION_LOCALE,
      withoutYear
    );

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(
        value,
        this.translateService.currentLang as LOCALIZATION_LOCALE,
        withoutYear
      );
    });

    return resultDate;
  }

  private getResult(
    input: Date,
    currentLang: LOCALIZATION_LOCALE,
    withoutYear: boolean
  ): string {
    const dateFormat = withoutYear
      ? this.getDateFormatWithoutYear(currentLang)
      : this.getDateFormat(currentLang);

    return DateTimeUtils.formatDateToString(input, dateFormat);
  }

  private getDateFormat(selectedLang: LOCALIZATION_LOCALE): DATE_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return DATE_FORMAT.DATE_FORMAT_VN;
      case LOCALIZATION_LOCALE.CZ:
      case LOCALIZATION_LOCALE.DE:
        return DATE_FORMAT.DATE_FORMAT_DE;
      case LOCALIZATION_LOCALE.FR:
        return DATE_FORMAT.DATE_FORMAT_FR;
      case LOCALIZATION_LOCALE.US:
        return DATE_FORMAT.DATE_FORMAT_US;
      default:
        return DATE_FORMAT.DATE_FORMAT_BACKEND;
    }
  }

  private getDateFormatWithoutYear(
    selectedLang: LOCALIZATION_LOCALE
  ): DATE_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return DATE_FORMAT.DATE_FORMAT_VN_WITHOUT_YEAR;
      case LOCALIZATION_LOCALE.CZ:
      case LOCALIZATION_LOCALE.DE:
        return DATE_FORMAT.DATE_FORMAT_DE_WITHOUT_YEAR;
      case LOCALIZATION_LOCALE.FR:
        return DATE_FORMAT.DATE_FORMAT_FR_WITHOUT_YEAR;
      case LOCALIZATION_LOCALE.US:
        return DATE_FORMAT.DATE_FORMAT_US_WITHOUT_YEAR;
      default:
        return DATE_FORMAT.DATE_FORMAT_BACKEND;
    }
  }
}
